import axios from 'axios';

const BASE_URL = 'https://pixabay.com/api/';
const API_KEY = '52251600-fd545eaf39516c2667db2508b';

axios.defaults.baseURL = BASE_URL;

export async function getImagesByQuery(query, page) {
  const response = await axios.get('', {
    params: {
      key: API_KEY,
      q: query,
      page,
      per_page: 15,
      image_type: 'photo',
      orientation: 'horizontal',
      safesearch: true,
    },
  });
  return response.data;
}
